import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { FoundRetailCustomer } from '../../customer/model/found-customer.model';
import { SearchResultsContainer } from '../../form/components/search-results/search-results.container';
import { useI18n } from '../../i18n/services/i18n.service';
import { TopSectionComponent } from '../../navigation/components/top-section/top-section.component';
import { CustomerSearchContainer } from './customer-search/customer-search.container';

@Component({
  selector: 'cdf-customer-search',
  imports: [CustomerSearchContainer, SearchResultsContainer, TopSectionComponent],
  template: `
    <cdf-top-section>
      <h2 class="mb-4x">{{ i18n('headings.customerSearch') }}</h2>
      <cdf-customer-search-container [hideVinSearch]="hideVinSearch()" [hideLicenseSearch]="hideLicenseSearch()" />
    </cdf-top-section>
    <cdf-search-results-container class="p-8x" (openCustomerProfile)="openCustomerProfile.emit($event)" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerSearchWrapper {
  protected readonly i18n = useI18n();

  readonly hideVinSearch = input(false, { transform: booleanAttribute });
  readonly hideLicenseSearch = input(false, { transform: booleanAttribute });

  readonly openCustomerProfile = output<FoundRetailCustomer>();
}
